import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalDocument {
  name: string;
  api_token: string;
}

export interface InternalDocumentListInfor {
  errors: unknown;
  InternalDocument: InternalDocument;
  isAuthenticated: boolean;
}

@Module
export default class InternalDocumentModule
  extends VuexModule
  implements InternalDocumentListInfor
{
  errors = {};
  InternalDocument = {} as InternalDocument;
  isAuthenticated = !!JwtService.getToken();

  get internalDocuments() {
    return this.internalDocumentListData;
  }

  @Mutation
  [Mutations.INTERNAL_DOCUMENTS_LIST_DATA](InternalDocuments) {
    this.internalDocumentListData = InternalDocuments;
  }

  @Action
  [Actions.INTERNAL_DOCUMENTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("vanbannoibo", payload)
        .then((data) => {
          this.context.commit(Mutations.INTERNAL_DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.INTERNAL_DOCUMENT_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/vanbannoibo", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.INTERNAL_DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.INTERNAL_DOCUMENT_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("vanbannoibo/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.INTERNAL_DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.INTERNAL_DOCUMENT_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/vanbannoibo",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
